import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-details-sn.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-details-sn.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../../../app-controller.service";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { ViewApplicationDetailsSnConstants } from "./view-application-details-sn.constants";
import { ViewApplicationBaseComponent } from "../../../shared/view-application-base/view-application-base.component";
import { ApplicationViewService } from "../../../shared/application-view.service";
import { RouterParamsService } from "../../../../shared/services/route-params.service";
let ViewApplicationDetailsSnComponent = class ViewApplicationDetailsSnComponent extends ViewApplicationBaseComponent {
    applicationViewService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appControllerService;
    changeDetectorRef;
    routerParamsService;
    detailsForm;
    applicationDetailsFormGroupName = ViewApplicationDetailsSnConstants.APPLICATION_DETAILS_FORM_GROUP_NAME;
    descriptionFormControlName = ViewApplicationDetailsSnConstants.DESCRIPTION_FORM_CONTROL_NAME;
    applicationTypeFormControlName = ViewApplicationDetailsSnConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    referenceNumberControlName = ViewApplicationDetailsSnConstants.REFERENCE_NUMBER_CONTROL_NAME;
    referenceNumberLabel = ViewApplicationDetailsSnConstants.REFERENCE_NUMBER_LABEL;
    descriptionLabel = ViewApplicationDetailsSnConstants.DESCRIPTION_FORM_LABEL;
    applicationTypeLabel = ViewApplicationDetailsSnConstants.APPLICATION_TYPE_FORM_LABEL;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    applicationTypes = [];
    validationMessages = ViewApplicationDetailsSnConstants.VALIDATION_MESSAGES;
    applicationTypeLookoutName = ViewApplicationDetailsSnConstants.APPLICATION_TYPE_LOOKOUT_NAME;
    getLookupsObservableSubscription;
    selectedApplicationSubscription;
    constructor(applicationViewService, aflaModuleStrategyService, selectedApplicationService, appControllerService, changeDetectorRef, routerParamsService) {
        super(applicationViewService, aflaModuleStrategyService, selectedApplicationService, routerParamsService);
        this.applicationViewService = applicationViewService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appControllerService = appControllerService;
        this.changeDetectorRef = changeDetectorRef;
        this.routerParamsService = routerParamsService;
        this.listenForRouteParamChange();
    }
    ngOnInit() {
        this.initForm();
        this.getLookups();
    }
    loadMetadata(stepMeta) {
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.appControllerService.selectedModuleID} and deleted eq false`,
        };
        this.getLookupsObservableSubscription = this.applicationViewService.getLookupsObservable(params).subscribe({
            next: (response) => {
                const lookups = response.value;
                if (lookups.length > 0) {
                    this.getLookupCompleted(lookups);
                }
            }, error: (error) => {
                this.appControllerService.handleServerErrorMessage(ViewApplicationDetailsSnConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    initForm() {
        this.detailsForm = this.aflaModuleStrategyService.form.get(this.applicationDetailsFormGroupName);
    }
    getLookupCompleted(lookups) {
        lookups.forEach((lookUp) => {
            if (lookUp.name?.toLowerCase()?.trim() === "applicationtype") {
                const lookUpContent = JSON.parse(lookUp.content);
                this.applicationTypes.push(lookUpContent);
            }
        });
        this.aflaModuleStrategyService.lookups.set(this.applicationTypeLookoutName, this.applicationTypes);
        this.changeDetectorRef.detectChanges();
        this.subscribeToSelectedApplication();
    }
    subscribeToSelectedApplication() {
        this.selectedApplicationSubscription = this.selectedApplicationService.$selectedApplication.subscribe((application) => {
            if (application) {
                this.setApplicationDetails(application);
            }
        });
    }
    setApplicationDetails(application) {
        this.detailsForm.get(this.descriptionFormControlName).setValue(application.description);
        this.detailsForm.get(this.descriptionFormControlName).disable();
        this.detailsForm.get(this.referenceNumberControlName).setValue(application.referenceNumber);
        this.detailsForm.get(this.referenceNumberControlName).disable();
        this.detailsForm.get(this.applicationTypeFormControlName).setValue(application.type);
        this.detailsForm.get(this.applicationTypeFormControlName).disable();
        this.changeDetectorRef.detectChanges();
    }
    handleRouteChange() {
    }
    static ctorParameters = () => [
        { type: ApplicationViewService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: RouterParamsService }
    ];
};
ViewApplicationDetailsSnComponent = __decorate([
    Component({
        selector: "app-view-application-details-sn",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationDetailsSnComponent);
export { ViewApplicationDetailsSnComponent };
